import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCaptchaStore = defineStore('captchaStore', () => {
  // Define state as refs
  const turnstileToken = ref('');
  const widgetId = ref('');

  // Actions to update state
  function setToken(token) {
    turnstileToken.value = token;
  }

  function setWidgetId(id) {
    widgetId.value = id;
  }

  function resetToken() {
    turnstileToken.value = '';
  }

  return {
    turnstileToken,
    widgetId,
    setToken,
    setWidgetId,
    resetToken,
  };
});
